import React from "react";
import { Card, Flex, Text } from "@chakra-ui/react";
import { Button } from "../components/ui/button";
import {
  LuDownload,
  LuFileSpreadsheet,
  LuExternalLink,
  LuPlug,
  LuWallet,
} from "react-icons/lu";
import { useModalState } from "../helpers/ModalProvider";

const McpInfoContainer = () => {
  const { showCreatePrepaidModal } = useModalState();

  return (
    <Card.Root>
      <Card.Header>
        <Card.Title
          fontSize="30px"
          fontWeight="bold"
          letterSpacing="-0.4px"
          lineHeight="32px"
        >
          Developer Tools & Resources
        </Card.Title>
      </Card.Header>
      <Card.Body>
        {/* MCP Server */}
        <Flex direction="column" gap={2} mb={6}>
          <Flex alignItems="center" gap={2}>
            <LuPlug size={18} color="#7c3aed" />
            <Text fontSize="lg" fontWeight="semibold" color="black">
              CoinCap MCP Server
            </Text>
          </Flex>
          <Text fontSize="sm" color="#52525b" lineHeight="20px">
            Connect AI agents and LLMs to the CoinCap API via our Model Context
            Protocol server. Available via GitHub, NPM, or as a .dxt file for
            Claude Desktop. All MCP calls are charged at the same rate as
            standard API calls.
          </Text>
          <Flex direction="row" gap={2} pt={2} flexWrap="wrap">
            <Button
              size="sm"
              variant="solid"
              colorPalette="purple"
              onClick={() =>
                window.open(
                  "https://github.com/CC3-0/coincap-mcp-server",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              <img
                src="/external/githubwhite.svg"
                alt="GitHub"
                style={{ width: 18, height: 18 }}
              />
              View Github Repo
            </Button>
            <Button
              size="sm"
              variant="solid"
              colorPalette="purple"
              onClick={() =>
                window.open(
                  "https://github.com/CC3-0/coincap-mcp-server/raw/refs/heads/main/coincap-mcp-clean.dxt",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              <LuDownload />
              Download .dxt file
            </Button>
          </Flex>
        </Flex>

        {/* Pre-paid API Keys */}
        <Flex
          direction="column"
          gap={2}
          mb={6}
          pt={4}
          borderTopWidth="1px"
          borderColor="#e4e4e7"
        >
          <Flex alignItems="center" gap={2}>
            <LuWallet size={18} color="#7c3aed" />
            <Text fontSize="lg" fontWeight="semibold" color="black">
              Pre-paid API keys
            </Text>
          </Flex>
          <Text fontSize="sm" color="#52525b" lineHeight="20px">
            Generate an API key and pre-purchase credits as you need them using
            the{" "}
            <Text as="span" fontWeight="bold">
              x402 protocol
            </Text>
            . Designed for AI agents, automated features, or simple testing.
            Pre-paid API keys allow you to purchase only the credits you need
            on-demand, and no CoinCap account is required. Each x402 key has its
            own pool of purchased credits. Credits cost $0.002 each — 500
            credits per $1 USDC on Base.
          </Text>
          <Flex direction="row" gap={2} pt={2} flexWrap="wrap">
            <Button
              size="sm"
              variant="solid"
              colorPalette="purple"
              onClick={() => showCreatePrepaidModal()}
            >
              Create a pre-paid API key
            </Button>
          </Flex>
        </Flex>

        {/* Quick Links */}
        <Flex
          direction="row"
          gap={2}
          pt={4}
          borderTopWidth="1px"
          borderColor="#e4e4e7"
          flexWrap="wrap"
        >
          <Button
            size="sm"
            bg="#f3e8ff"
            border="1px solid"
            borderColor="#e9d5ff"
            color="#641ba3"
            onClick={() => window.open("/api-docs/", "_blank", "noopener,noreferrer")}
          >
            <LuFileSpreadsheet />
            API Docs
          </Button>
          <Button
            size="sm"
            bg="#f3e8ff"
            border="1px solid"
            borderColor="#e9d5ff"
            color="#641ba3"
            onClick={() => window.open("https://coincap.io", "_blank", "noopener,noreferrer")}
          >
            <LuExternalLink />
            CoinCap.io
          </Button>
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};

export default McpInfoContainer;
